import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../common/theme/ISpcTheme';

export type StockLiteSliderClasses = 'container' | 'iconWrapper' | 'title' | 'visible' | 'icon' | 'sectionWrapper';

const stockLiteListStyle = makeStyles<ISpcTheme, StockLiteSliderClasses>(
  theme => ({
    container: {
      [theme.breakpoints.down('sm')]: {
        display: 'block',
        margin: 'auto',
        width: '100%',
      },
    },
    '@keyframes stockLite_bounce': {
      '0%': {
        transform: 'translateY(0)',
      },
      '50%': {
        transform: 'translateY(10px)',
      },
    },
    iconWrapper: {
      width: 40,
      height: 40,
      margin: '0 auto 20px',
    },
    icon: {
      transition: 'opacity 0.8s',
      opacity: 0,
      animationName: '$stockLite_bounce',
      animationDuration: '2s',
      fontSize: '40px',
      animationIterationCount: 'infinite',
    },
    visible: {
      opacity: 1,
    },
    title: {
      margin: 20,
      display: 'inline-block',
    },
    sectionWrapper: {},
  }),
  { name: 'GqlCustomise_StockList' },
);

export default stockLiteListStyle;
